import { VerticalProductCardCarouselContainer } from '@domains/pdp-common';

import { FirstPurchaseDeals } from '../components/FirstPurchaseDeals';
import { SectionTitle } from '../components/SectionTitle';
import { useFirstPurchaseDealsService } from '../services/useFirstPurchaseDealsService';

export const FirstPurchaseDealsContainer = () => {
  const { title, subTitle, itemList, button, isHide, onImpressionProduct, onClickProduct, onSaveProduct, onClickMore } =
    useFirstPurchaseDealsService();

  if (isHide) {
    return null;
  }

  return (
    <FirstPurchaseDeals button={button} onClickMore={onClickMore} isLazyLoad>
      <VerticalProductCardCarouselContainer
        defaultSize='small'
        title={<SectionTitle title={title} subTitle={subTitle} />}
        items={itemList}
        onImpression={(item, index) => onImpressionProduct(item.catalog_product_id || '', index, item.log)}
        onClick={(item, index) => onClickProduct(item.catalog_product_id || '', index, item.log)}
        onLikeClick={(checked, item, index) => onSaveProduct(checked, item, index)}
      />
    </FirstPurchaseDeals>
  );
};
